import { render } from "./NebulaCover.vue?vue&type=template&id=b487c86c"
import script from "./NebulaCover.vue?vue&type=script&lang=js"
export * from "./NebulaCover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__